<template>
  <div class="animated fadeIn">
    <div class="row mb-10" v-cloak>
      <div class="col-12">
        <div class="font-bold mb-15">Sales Planner</div>
        <div class="box-mini p-15 pt-20 pb-20 mb-15">
          <div class="row">
            <div class="col-md-4">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Filter by Month</div>
                </div>
                <div class="col-sm-9">
                  <input
                    type="month"
                    class="form-control"
                    name="event_date"
                    min="2000-01"
                    v-model="dateTodayData"
                    @change="changeDate"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Filter Branch</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select
                    name="branch"
                    v-model="branch_id"
                    :disabled="getRoleId == 17 || getRoleId == 22 || getRoleId == 31 || getRoleId == 1 ? false : true"
                    @change="changeBranch"
                    class="form-control"
                  >
                    <option :value="null" v-if="getRoleId != 7">
                      Please select
                    </option>
                    <option :value="null" v-if="getParadigmId == '1011928'">
                      Please select
                    </option>
                    <option
                      v-for="item in dataBranch"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </div>
              </div>
            </div>
            <div
              class="col-md-4"
              v-if="
                getRoleId == 3 ||
                getRoleId == 4 ||
                getRoleId == 13 ||
                getRoleId == 17 ||
                getRoleId == 18 ||
                getRoleMappingId.includes(22) ||
                getRoleId == 27 ||
                getRoleId == 6 ||
                getRoleId == 20 ||
                getRoleId == 8
              "
            >
              <div class="row align-items-center">
                <div class="col-sm-3">
                  <div class="label-name">Sales</div>
                </div>
                <div class="col-sm-9">
                  <b-form-select
                    name="personal_trainer"
                    @change="changePt"
                    v-model="pt_id"
                    class="form-control"
                  >
                    <option :value="null" selected v-if="getRoleId != 7">
                      Please select
                    </option>
                    <option
                      :value="null"
                      selected
                      v-if="getParadigmId == '1011928'"
                    >
                      Please select
                    </option>
                    <option
                      v-for="(item, index) in itemsPT"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.fullname }}
                    </option>
                  </b-form-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Table -->



        <!-- detail selected -->
        <b-modal
          modal-class="modal-custom-image"
          size="lg"
          hide-footer
          :ref="'is_item_selected'"
          centered
          title="Selected"
        >
          <div
            class="col-12 custom-manipulator col-custom-0 text-right"
            :class="{
              'box-off-footer': compareDate(
                rowSelectedData2[0] == null ? '' : rowSelectedData2[0].date
              )
                ? true
                : false,
            }"
          >
            <a
              @click="
                openPage(
                  '/ptPlannerNew/add?date=' +
                    getFullDate(rowSelectedData2[0].date) +
                    '&planner_time=' +
                    rowSelectedData2[0].rowTimeId +
                    '&pt_id=' +
                    current_pt_id +
                    '&branch_id=' +
                    current_branch_id
                )
              "
              class="mr-10 color-primary btn-add-planner"
            >
              <i class="fas fa-plus"></i>
              Add
            </a>
          </div>
          <br />
          <table
            class="w-100"
            :class="{
              'box-off-footer': compareDate(
                rowSelectedData2[0] == null ? '' : rowSelectedData2[0].date
              )
                ? true
                : false,
            }"
          >
            <thead>
              <tr>
                <th style="color: white;">Desc</th>
                <th style="color: white;">Action</th>
              </tr>
            </thead>
            <tbody v-if="rowSelectedDataShowData == true">
              <tr
                v-for="(rowData, index) in rowSelectedData"
                :key="index + 'xyz'"
              >
                <td style="padding-left: 10px;">
                  <div v-if="rowData.length != 0 && rowData.member_id != 0">
                    <p style="font-size: 12px; font-weight: bold; margin: 0;">
                      {{
                        rowData.member
                          ? rowData.member.first_name +
                            " " +
                            rowData.member.last_name
                          : rowData.lead
                          ? rowData.lead.name
                          : ""
                      }}
                    </p>
                  </div>
                  <div v-else>Personal Trainer</div>
                  <div class="row" v-if="rowData.length != 0">
                    <div
                      class="col-12"
                      v-if="rowData.pt_planner_activity_id != 0"
                    >
                      {{ rowData.pt_planner_activity.name }}
                    </div>
                  </div>
                </td>
                <td style="padding-left: 10px;">
                  <div class="col-12 pl-0">
                    <a
                      :class="{ off: true }"
                      :key="rowData.id + 'editPlanner'"
                      @click="
                        openPage(
                          '/ptPlannerNew/edit?planner_id=' +
                            rowData.id +
                            '&pt_id=' +
                            rowData.personal_trainer_id
                        )
                      "
                      class="color-primary btn-edit-planner"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- <div class="detail-data mb-8">
            <div v-for="(rowData, index) in rowSelectedData" :key="index+'asd'">
              <div v-if="rowData.length != 0 && rowData.member_id != 0">
                {{rowData.member ? rowData.member.first_name + ' ' + rowData.member.last_name: rowData.lead ? rowData.lead.name : ''}}
              </div>
              <div v-else>
                Personal Trainer
              </div>

            </div>
          </div> -->
        </b-modal>
        <!-- End Selected -->
      </div>

    </div>
    <div>
    <div class="col-6" style="padding: 0;">
        <div class="box-mini mb-15">
          <table>
            <tr style="text-align: center;">
              <td
                class="is-weeks-not-selected"
                v-for="we in setWeeksDefaultList"
                :key="we.w"
                @click="onChangeWeeks(we.w)"
                :class="{
                  'is-weeks-selected': we.w == setWeeks ? true : false,
                }"
              >
                Week {{ we.w }}
              </td>
            </tr>
          </table>
        </div>
      </div>
  </div>

    <listAllSales :itemSales="itemsPT" :dataPlanner="dataPlanner" :pt_planner_time="itemTime" :setWeeks="setWeeks" :dateTodayData="dateTodayData" v-if="pt_id == null && !pt_id" />
    <listSelectSales :itemSales="itemsPT" :dataPlanner="dataPlanner" :sales_id="pt_id" :pt_planner_time="itemTime" :setWeeks="setWeeks" :dateTodayData="dateTodayData" v-else/>
    <div v-if="loadingActive == true" class="loading-container">
      <div class="wrap-screen w-100 h-100">
        <img :src="`/svg-loaders/oval.svg`" width="60" alt="" />
        <div class="title-loading color-white">Loading...</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.detail-data-all {
  display: block;
  height: 45px;
  max-height: 45px;
  overflow: auto;
}

table {
  width: 100%;
  font-size: 10px;
}

td {
  // outline:1px solid #ccc;
  height: 45px;
  max-height: 30px;
}

// tr:nth-child(even){background-color: #f2f2f2;}

td,
th {
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
  // padding: 8px;
  padding: 0;
  border-left: none;
}

th {
  background-color: #2f353a;
  padding: 5px;
}

.class-selected:hover {
  // background-color: #ffb326;
  background-color: #ffb326;
  cursor: pointer;
}

.is-weeks-not-selected {
  cursor: pointer;
}

.is-weeks-not-selected:hover {
  cursor: pointer;
  background-color: #ffb326;
  color: white;
}

.is-weeks-selected {
  background-color: #ffb326;
  cursor: pointer;
  color: white;
}
</style>

<script>
import axios from "axios";
import { Auth } from "@/api";
import moment from "moment";
import Pagination from "@/views/component/pagination";
import { ModelSelect } from "vue-search-select";
import weekComponent from './week.vue'
import listAllSales from './listAllSales.vue'
import listSelectSales from './listSelectSales.vue'
export default {
  name: "ptPlannerNew",
  components: {
    ModelSelect,
    "app-pagination": Pagination,
    weekComponent,
    listAllSales,
    listSelectSales
  },
  data: function () {
    return {
      past_member_date: moment(new Date()).add(-1, 'M').format("YYYY-MM"),
      past_member_data: [],
      setWeeks: 1,
      load:false,
      detailPt:'',
      dataPlanner:[],
      setWeeksDefaultList: [
        {
          w: 1,
        },
        {
          w: 2,
        },
        {
          w: 3,
        },
        {
          w: 4,
        },
        {
          w: 5,
        },
      ],
      showDataFilterByPtPlanner: false,
      dataBranch: [],
      rowSelectedData: [],
      rowSelectedData2: [],
      rowSelectedDataShowData: false,
      current_branch_id: null,
      branch_id: Auth.Session.get().paradigm_branch_id,
      current_pt_id: null,
      loadingActive: false,
      getRoleId: Auth.Session.get().paradigm_role,
      getParadigmId: Auth.Session.get().paradigm_id,
      getRoleMappingId: Auth.Session.get().paradigm_role_mapping_id,
      pt_id: null,
      current_pt_name: null,
      itemsPT: [],
      itemsPT2: [],
      totalActiveMember: "",
      dateTodayData: moment(new Date()).format("YYYY-MM"),
      dateTodayDataWeek: moment(new Date()).format("DD/MM/YYYY"),
      dataActivity: [],
      config: {
        altInput: true,
        altFormat: "F Y",
        dateFormat: "Y-m-d",
      },
      addPlanner: {
        personal_trainer_id: "",
        pt_planner_activity_id: null,
        date: "",
        pt_planner_time_id: 0,
        member_id: 0,
      },
      ptPlannerStatistic: {},
      dataPlannerMember1: [],
      dataPlannerMember2: [],
      dataPlannerMember3: [],
      totalMemberAlreadyExpired: [],
      dataPlannerPHAappointment: [],
      dataPlannerPHAshow: [],
      dataPlannerPtAppointmentCancel: [],
      dataPlannerPtAppointmentNoShow: [],
      planner_id: "",
      planner_leave_id: "",
      status_planner: null,
      checkData: "",
      member_name: null,
      plannerActivity: [],
      plannerActivity2: [],
      listMember: [],
      itemTime: [],
      listData: [],
      listDataLeave: [],
      listDataNew1: [],
      listDataNew2: [],
      listDataNew3: [],
      listDataNew4: [],
      listDataNew5: [],
      listData_length: null,
      optionsMember: [{ value: 0, text: "Please select" }],
      currentTotalDay: moment(new Date(), "YYYY-MM").daysInMonth(),
      currentNumberMonth: moment(new Date()).format("M"),
      currentNumberYear: moment(new Date()).format("YYYY"),
      valueActivity: [],
      total_member: 0,
    };
  },
  methods: {
    openPageNewTab(path) {
      let route = this.$router.resolve({path: path});
      window.open(route.href, '_blank');
    },
    removeDuplicates(originalArray, prop) {
        var newArray = [];
        var lookupObject  = {};

        for(var i in originalArray) {
          lookupObject[originalArray[i][prop]] = originalArray[i];
        }

        for(i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    },
    formatingDateTime(val) {
      return moment(val).format("YYYY-MM-DD HH:mm")
    },
    blockRows2(data) {
      for (let i = 0; i < data.time.length; i++) {
        if (data.time[i].activity.length != 0) {
          for (let d = 0; d < data.time[i].activity.length; d++) {
            if (
              data.time[i].activity[d].pt_planner_activity_id == 13 ||
              data.time[i].activity[d].pt_planner_activity_id == 14 ||
              data.time[i].activity[d].pt_planner_activity_id == 15 ||
              data.time[i].activity[d].pt_planner_activity_id == 16
            ) {
              return true;
            } else {
              return false;
            }
          }
        }
      }
    },
    showModalDeletePtPlannerByActivity(data) {
      var activity_id = []
      for (let i = 0; i < data.time.length; i++) {
        if (data.time[i].activity.length != 0) {
          for (let d = 0; d < data.time[i].activity.length; d++) {
            if (
              data.time[i].activity[d].pt_planner_activity_id == 13 ||
              data.time[i].activity[d].pt_planner_activity_id == 14 ||
              data.time[i].activity[d].pt_planner_activity_id == 15 ||
              data.time[i].activity[d].pt_planner_activity_id == 16
            ) {
              activity_id.push(data.time[i].activity[d].id)
            }
          }
        }
      }
      console.log(activity_id)
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((v) => {
        if (v.value) {
          console.log(activity_id)
          if (activity_id.length > 0) {
            for (let b = 0; b < activity_id.length; b++) {
              axios.delete('crm/v1/pt_planner/delete/by_activity/'+ activity_id[b]).then(response => {
                this.$swal('Deleted', 'You Activity successfully deleted!', 'success')
                console.log(response)
                // this.$router.go()
                this.fetchData()
              }).catch(error => {
                console.log('error', error)
              })
            }
          }
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
          return;
        }
      }).catch(() => {
        console.log('Cancelled!')
      })
    },
    compareDate(value) {
      var rowDate = moment(value).format("YYYY-MM-DD");
      var today = moment(new Date()).format("YYYY-MM-DD");
      if (rowDate < today) {
        return true;
      }
    },
    cutTime(value) {
      return value.slice(0, -3);
    },
    combineName(event) {
      if (event == 1) {
        // console.log(this.listDataNew1)
        return this.listDataNew1;
      }
      if (event == 2) {
        return this.listDataNew2;
      }
      if (event == 3) {
        return this.listDataNew3;
      }
      if (event == 4) {
        return this.listDataNew4;
      }
      if (event == 5) {
        return this.listDataNew5;
      }
    },
    onChangeWeeks(ev) {
      // console.log(ev)
      this.setWeeks = ev;
      this.getData()

      // localStorage.setItem("ptPlannerWeeks", `${ev}`);
    },
    showModal2(id, date, pt_planner_time_id) {
      // console.log(id)
      this.$refs[id].show();
    },
    showModalDetail(id, data, itemData, rowTimeID, is_showData, pt_id) {
      // console.log(is_showData)
      this.rowSelectedData = [];
      this.rowSelectedData2 = [];
      this.rowSelectedDataShowData = is_showData;

      this.rowSelectedData = data;
      this.rowSelectedData2.push({
        date: itemData.date,
        rowTimeId: rowTimeID,
      });

      this.$refs[id].show();
    },
    filterActivity(event) {
      // if(init===1){
      //   return this.valueActivity[event-1].value
      // }else{
      //   return (this.listData.filter(item => (item.pt_planner_activity && item.pt_planner_activity.id === event) && this.toMonth(item.date) == this.currentNumberMonth)).length
      // }
      return this.valueActivity[event - 1].value;
    },

    getWeek(date) {
      var prefixes = ["1", "2", "3", "4", "5"];
      return prefixes[Math.ceil(date.getDate() / 7)];
    },
    whichWeek(value) {
      // return moment(new Date()).format('YYYY WWWW MMMM')
      var dateNew = moment(new Date(value)).format("YYYY-MM-DD");
      // var year = moment(new Date()).format('YYYY')
      // var month_number = moment(new Date()).format('M')
      let week = this.getWeek(new Date(dateNew));
      return week;
    },
    getYearMonth(value) {
      return moment(new Date(value)).format("YYYY-MM");
    },
    getFullDate(value) {
      return moment(new Date(value)).format("YYYY-MM-DD");
    },
    todayNumber() {
      return moment().isoWeekday();
    },
    getNameDay(value) {
      moment.locale("en");
      return moment(new Date(value)).format("dddd");
    },
    getDay(value) {
      moment.locale("en");
      return moment(new Date(value)).format("D");
    },
    getMonth(value) {
      return moment(new Date(value)).format("MMM");
    },
    getYear(value) {
      return moment(new Date(value)).format("YYYY");
    },
    getNumberDayInWeek(value) {
      return moment(new Date(value)).isoWeekday();
    },
    parseDateTime3(value) {
      var curr = new Date();
      var first = curr.getDate() - curr.getDay();
      var monthName = new Date(curr.getTime());
      moment.locale("en");
      return moment(new Date(monthName)).format("MMMM YYYY");
    },
    parseImg(value) {
      return Auth.apiUrl + "crm/v1/img/banner/" + value;
    },
    getDaysInMonth(month, year) {
      var date = new Date(year + "-" + month + "-1");
      var days = [];
      while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
      }
      return days;
    },

    changeDate(event) {
      this.getData()
    },

    changeBranch() {
      this.getSales()
      this.getData()
    },

    changePt() {
      this.detailPt = this.itemsPT.find(x => x.id == this.pt_id)
    },

    openPage(event) {
      this.$router.push(event);
    },
    refreshBranch() {

    },
    getSales() {
      let branch_id = this.branch_id !== null ? this.branch_id : ''
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios
        .get("crm/v1/sales?branch_id=" + branch_id + "&status=active" )
        .then((response) => {
          console.log("tes")
              this.itemsPT = response.data.data.rows;
          // this.dataBranch = response.data.data.rows;
          // console.log('test', response)
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    getData() {
      let branch_id = this.branch_id !== null ? this.branch_id : ''

      if (branch_id != '') {
        let sales_id = this.pt_id !== null ? this.pt_id : ''
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios
        .get("crm/v1/leads_activities/sales?branch_id=" + branch_id + '&sales_id=' + sales_id + '&month=' + this.dateTodayData
        + '&week=' + this.setWeeks)
        .then((response) => {
          console.log('leads')
          console.log(response)
          this.dataPlanner = response.data.data.rows
          // this.dataBranch = response.data.data.rows;
          // console.log('test', response)
        })
        .catch((error) => {
          console.log("error", error);
        });
      }

    },
    fetchData() {
      // get Branch
      axios
        .get("fitness/v1/branch/")
        .then((response) => {
          console.log("tes")
              this.dataBranch = response.data.data.rows;
          // this.dataBranch = response.data.data.rows;
          // console.log('test', response)
        })
        .catch((error) => {
          console.log("error", error);
        });

        axios
        .get("crm/v1/pt_planner_time?sorting=id&sorting_type=asc")
        .then((response) => {
           // this.itemTime = response.data.data.rows
           var dataTime = [...response.data.data.rows];

            var getLength = dataTime.length;
            dataTime.splice(getLength - 1, 1);
            this.itemTime = dataTime;
          console.log(this.itemTime)
        })
        .catch((error) => {
          console.log("error", error);
        });

        this.getData()
    },
  },
  created() {
    this.fetchData()
    this.getSales()
  },
  mounted() {
  },
  destroyed() {

  },
};
</script>
